import { IDisplayOptions } from '@modeso/types__aumico-lib-annualreport-be';

/** "In Tausend" prints every monetary value divided by this; 1 leaves the values untouched. */
export const THOUSANDS_VALUE_DIVISOR = 1000;
export const NO_VALUE_DIVISOR = 1;
/** The unit label is "T" + currency code ("TCHF", "TEUR") in every language. */
export const THOUSANDS_CURRENCY_PREFIX = 'T';

export class PdfTronMapperHelper {
    public static getNumberFormatAndDecimalPlaces(
        printDisplayOptions: IDisplayOptions,
        hideDecimalPlacesValues: boolean,
        hideDecimalPlacesRatios: boolean,
        roundToThousands = false,
    ): {
        numberOfDecimalPlacesValues: number;
        numberFormatValues: string;
        numberOfDecimalPlacesRatios: number;
        numberFormatRatios: string;
        valueDivisor: number;
    } {
        let numberOfDecimalPlacesValues = 2;
        let numberOfDecimalPlacesRatios = 2;
        let numberFormatValues = '1.2-2';
        let numberFormatRatios = '1.2-2';
        if (hideDecimalPlacesValues) {
            // Round to the printed precision; rounding to two places first and then formatting
            // without decimals rounds twice once the values are in thousands (12.497 → 12.50 → 13).
            numberOfDecimalPlacesValues = 0;
            numberFormatValues = '1.0-0';
        }
        if (hideDecimalPlacesRatios) {
            numberOfDecimalPlacesRatios = 2;
            numberFormatRatios = '1.0-0';
        }

        return {
            numberOfDecimalPlacesValues,
            numberFormatValues,
            numberOfDecimalPlacesRatios,
            numberFormatRatios,
            valueDivisor: PdfTronMapperHelper.getValueDivisor(roundToThousands),
        };
    }

    public static getValueDivisor(roundToThousands: boolean): number {
        return roundToThousands ? THOUSANDS_VALUE_DIVISOR : NO_VALUE_DIVISOR;
    }

    /**
     * Divides a monetary value before it is rounded and formatted. Null, undefined and non-finite
     * values pass through unchanged so the existing null/empty handling of every call site stays intact.
     */
    public static scaleValue<T extends number | null | undefined>(value: T, valueDivisor: number): T {
        if (value == null || valueDivisor === NO_VALUE_DIVISOR || !Number.isFinite(value)) {
            return value;
        }
        return (value / valueDivisor) as T;
    }

    /** "CHF" → "TCHF" when the section prints in thousands; undefined stays undefined. */
    public static getCurrencyLabel(currency: string | null | undefined, roundToThousands: boolean): string | undefined {
        if (currency == null) {
            return undefined;
        }
        return roundToThousands ? THOUSANDS_CURRENCY_PREFIX + currency : currency;
    }
}
